module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village//floor.png?v=8c276335";